import { FeatureTogglesConfiguration } from '../../shared/providers/FeatureTogglesProvider/types'
import configuration from './configuration.js'
// TODO: remove ts-ignore when Platform is refactored
// @ts-ignore
import Platform from './platforms/index.js'

const getFeatureTogglesBaseURL = (): string => {
  const isProd = window.location.href.includes('prod')
  return isProd
    ? configuration.featureTogglesBaseURL.prod
    : configuration.featureTogglesBaseURL.dev
}

// eslint-disable-next-line import/prefer-default-export
export const FEATURE_TOGGLES_CONFIGURATION: FeatureTogglesConfiguration = {
  urlBase: getFeatureTogglesBaseURL(),
  // @ts-ignore
  platform: Platform.featureTogglePlatform,
}
